import { Delete } from "@mui/icons-material";
import { Button, IconButton, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { createCategory, createSubCategory } from "api/services/categories";
import DrawerWrapper from "components/DrawerWrapper";
import LoadingButton from "components/LoadingButton";
import { snack } from "components/toast";
import _ from "lodash";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { DialogProps } from "types";
import { handleError } from "utils/handleError";

interface StateProps {
  name: string;
  color: string;
  subCategories: Array<{ name: string }>;
}

let initialState = {
  name: "",
  color: "",
  subCategories: [],
};

function AddSubCategory({ data, open, setOpen }: any) {
  const queryClient = useQueryClient();
  const [state, setState] = useState<StateProps>(_.cloneDeep(initialState));
  const [subCategory, setSubCategory] = useState<string>("");

  const { mutate, isLoading } = useMutation(createSubCategory, {
    onSuccess: () => {
      snack.success("Service Sub Category Created");
      queryClient.invalidateQueries("categories");
      setState(_.cloneDeep(initialState));
      setSubCategory("");
      setOpen(false);
    },
    onError: (err: any) => {
      console.log(err?.response?.data?.message)
      if (err?.response?.response?.data?.message?.[0].includes('subCategories')) {
        snack.error('Subcategory name cannot contain /, |, *, ?, ", <, >');
      } else {
        snack.error(handleError(err));
      }
    },
  });

  const handleSubmit = () => {
    if (!subCategory) return snack.error("Enter Subcategory");
    if (/[\/\|\*\?"<>]/.test(subCategory)) return snack.error('Subcategory name cannot contain /, |, *, ?, ", <, >')
    mutate({
      name: subCategory,
      categoryId: data.id,
    });
  };

  return (
    <DrawerWrapper open={open} setOpen={setOpen} title="Add Sub Category">
      <TextField
        variant="outlined"
        fullWidth
        disabled
        size="small"
        value={data.name}
        label="Category"
      />
      <TextField
        variant="outlined"
        fullWidth
        onChange={(e) => setSubCategory(e.target.value)}
        size="small"
        sx={{ mt:2 }}
        value={subCategory}
        label="Sub Category Name"
      />
      <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
        <LoadingButton
          onClick={handleSubmit}
          loading={isLoading}
          disabled={isLoading}
          fullWidth
          loadingColor="white"
          title="Create Sub Category"
          color="secondary"
        />
      </Box>
    </DrawerWrapper>
  );
}

export default AddSubCategory;
